import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// icons
import { Icon } from '@iconify/react';
// @mui
import { Box, IconButton,Typography, Tooltip } from '@mui/material';
import { Link } from "react-router-dom";

// ----------------------------------------------------------------------

const Iconify = forwardRef(({ icon,id, tooltip, titulo, link, onClick, width = 20, sx, ...other }, ref) => (
  <Tooltip title={tooltip} id={id}>
    {link ? <Link to={link} id={id}>
      <IconButton id={id} aria-label={tooltip} onClick={onClick}>
        <Box id={id} ref={ref} component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
      </IconButton>
    </Link> :
      <IconButton id={id} aria-label={tooltip} onClick={onClick}>
        <Box id={id} ref={ref} component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
 
      </IconButton>}
  </Tooltip>
));

Iconify.propTypes = {
  sx: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  tooltip: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  link: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onClick: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),



};

export default Iconify;
